import { Form } from "@circle-react-uikit/Form";
import { useFormItem } from "../../DefaultEditorV2/useFormItem";

export interface TextareaFieldProps {
  label: string;
  name: string;
  rows?: number;
}

export const TextareaField = ({
  name,
  label,
  rows = 7,
}: TextareaFieldProps) => {
  const { getFormItemProps } = useFormItem();

  return (
    <Form.Item
      name={name}
      label={label}
      {...getFormItemProps({
        // eslint-disable-next-line i18next/no-literal-string -- False positive
        className: "!block",
        // eslint-disable-next-line i18next/no-literal-string -- False positive
        labelClassName: "!mb-1",
      })}
    >
      <Form.Input name={name} variant="textarea" rows={rows} />
    </Form.Item>
  );
};
